import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./MfaqQuestionHeader.module.css";

type MfaqQuestionHeaderProps = {
  label: string;
  questionText: string;
};

function MfaqQuestionHeader({ label, questionText }: MfaqQuestionHeaderProps) {
  return (
    <div className={styles["root"]}>
      <FixaText textStyle="Body.M" className={styles["label"]}>
        {label}
      </FixaText>
      <FixaText textStyle="Heading.L" tagName="h2">
        {questionText}
      </FixaText>
    </div>
  );
}

export default MfaqQuestionHeader;
